export const REQUIRED_ERROR = 'Required';
export const NUMBER_SHOULD_BE_POSITIVE_ERROR = 'Please enter a value greater than 0.';
export const TYPE_NUMBERS_ONLY_ERROR = 'Please enter a numeric value.';
export const GREATER_THAN_ZERO_ERROR = 'Please enter a value grater than zero.';
export const BETWEEN_0_AND_100_ERROR = 'Value should be between 0 and 100';
export const OTE_IS_LOWER_THAN_BASE_SALARY_ERROR = 'Your OTE cannot be lower than your base salary.';
